// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Y6iZ","name":"Header_name__3EIvd","birthday":"Header_birthday__1RoDJ","skeleton":"Header_skeleton__1vCet"};